export type NonOptionalKeys<T> = { [k in keyof T]-?: undefined extends T[k] ? never : k }[keyof T];

export function populateKeysToValue<T extends Object>(object: T) {
    return Object.keys(object).reduce<{ [key in keyof T]: keyof T }>((map: any, key: string) => {
        map[key] = key;
        return map;
    }, {} as any);
}

// Convert an object to another new object with desirable keys if available
export function trimObjectWithKeys<T extends string>(object: { [key: string]: any }, keys: T[]): { [key in T]: any } {
    const newObj: { [key in T]: any } = {} as any;
    for (const key of keys) {
        newObj[key] = object[key];
    }
    return newObj;
}

// Create a typed object with inferred keys. This is a curry function.
export const asTypedObject =
    <E>() =>
    <T>(et: { [K in keyof T]: E }) =>
        et;
